<script lang="ts" module>
  import type { AnyConfigurationOption } from '@/teoCore/config/config-setup.types';
  import InputButton from '@/ui/elements/buttons/InputButton.svelte';

  export interface ConfigCardProps<TOption extends AnyConfigurationOption> {
    title: string;
    description: string;
    options: TOption[];
    value?: TOption['id'] | false | null | undefined;
    onchange?: (value: TOption['id']) => void;
    groupName: string;
  }
</script>

<script lang="ts" generics="TOption extends AnyConfigurationOption">
  let {
    title,
    description,
    options,
    value: currentValue,
    onchange,
    groupName,
    ...rest
  }: ConfigCardProps<TOption> = $props();

  let handleChange = (value: TOption['id'], selected: boolean) => {
    if (selected) {
      onchange?.(value);
    }
  };
</script>

<div {...rest} class="fc gap-3 rounded-md bg-prim p-3">
  <div class="fc gap-1">
    <h2 class="text-sm font-medium">{title}</h2>
    <p class="text-xs">{description}</p>
  </div>
  <div class="fr flex-wrap gap-2">
    {#each options as option (option.label)}
      {#if option.type !== 'HIDDEN'}
        <InputButton
          name={groupName}
          label={option.label}
          value={option.id}
          checked={option.id === currentValue}
          onchange={(selected) => handleChange(option.id, selected)}
          disabled={option.type === 'INACTIVE'}
        />
      {/if}
    {/each}
  </div>
</div>
